var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [
      _c("h1", [
        _vm._v(_vm._s(_vm.$t("settings.documentTemplate.editFormTitle")))
      ]),
      _c(
        "div",
        { staticClass: "mt-3 elevation-12 grey lighten-4" },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                [
                  _c("h3", [
                    _vm._v(
                      _vm._s(_vm.$t("settings.documentTemplate.description"))
                    )
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("settings.documentTemplate.listOfAvailableTags")
                      ) +
                      ": "
                  ),
                  _c("br"),
                  _c("ul", [
                    _c("li", [
                      _vm._v(
                        "{yyyy} - " +
                          _vm._s(_vm.$t("settings.documentTemplate.yyyy"))
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "{yy} - " +
                          _vm._s(_vm.$t("settings.documentTemplate.yy"))
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "{mm} - " +
                          _vm._s(_vm.$t("settings.documentTemplate.mm"))
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "{m} - " + _vm._s(_vm.$t("settings.documentTemplate.m"))
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "{dd} - " +
                          _vm._s(_vm.$t("settings.documentTemplate.dd"))
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "{d} - " + _vm._s(_vm.$t("settings.documentTemplate.d"))
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "{KRAJ/ZAGR} - " +
                          _vm._s(_vm.$t("settings.documentTemplate.krajZagr"))
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        " {Krajowa/Zagraniczna} - " +
                          _vm._s(
                            _vm.$t(
                              "settings.documentTemplate.krajowaZagraniczna"
                            )
                          ) +
                          " "
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "{numer} - " +
                          _vm._s(_vm.$t("settings.documentTemplate.number"))
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "{NN} - " +
                          _vm._s(_vm.$t("settings.documentTemplate.nn"))
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "{NNN} - " +
                          _vm._s(_vm.$t("settings.documentTemplate.nnn"))
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "{NNNN} - " +
                          _vm._s(_vm.$t("settings.documentTemplate.nnnn"))
                      )
                    ])
                  ]),
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      staticClass: "mt-3",
                      attrs: { "lazy-validation": "" },
                      model: {
                        value: _vm.formValid,
                        callback: function($$v) {
                          _vm.formValid = $$v
                        },
                        expression: "formValid"
                      }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("settings.documentTemplate.mask") + "*",
                          rules: _vm.documentNumberTemplate.validateTemplateMask()
                        },
                        model: {
                          value: _vm.documentNumberTemplate.template_mask,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.documentNumberTemplate,
                              "template_mask",
                              $$v
                            )
                          },
                          expression: "documentNumberTemplate.template_mask"
                        }
                      }),
                      _c("v-select", {
                        attrs: {
                          items: _vm.documentType,
                          label:
                            _vm.$t("settings.documentTemplate.documentType") +
                            "*",
                          rules: _vm.documentNumberTemplate.document_type_rules
                        },
                        model: {
                          value: _vm.documentNumberTemplate.document_type,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.documentNumberTemplate,
                              "document_type",
                              $$v
                            )
                          },
                          expression: "documentNumberTemplate.document_type"
                        }
                      }),
                      _c("v-select", {
                        attrs: {
                          items: _vm.numberType,
                          label:
                            _vm.$t(
                              "settings.documentTemplate.numberResetType"
                            ) + "*",
                          rules: _vm.documentNumberTemplate.number_type_rules
                        },
                        model: {
                          value: _vm.documentNumberTemplate.number_type,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.documentNumberTemplate,
                              "number_type",
                              $$v
                            )
                          },
                          expression: "documentNumberTemplate.number_type"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card",
            [
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.cancel()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: !_vm.formValid,
                        color: "blue darken-1",
                        text: ""
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.save")) + " ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }